import { render, staticRenderFns } from "./oncall-time-slot.vue?vue&type=template&id=7060f344&"
import script from "./oncall-time-slot.vue?vue&type=script&lang=ts&"
export * from "./oncall-time-slot.vue?vue&type=script&lang=ts&"
import style0 from "./oncall-time-slot.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports